interface MenuItem {
  id?: number;
  label?: string;
  path?: string;
  unauthorized?: boolean;
  hiddenFor?: string[];
  subMenu?: MenuItem[];
  [key: string]: any;
}

interface TransformMenuOptions {
  isAuthorized?: boolean;
  hasNews?: boolean;
  location?: string;
}

export function transformMenu(
  baseMenu: MenuItem[],
  options: TransformMenuOptions
): MenuItem[] {
  const { isAuthorized = false, hasNews = false, location } = options;
  
  const filteredMenu = baseMenu.filter((menuItem) => {
    if (menuItem.unauthorized && isAuthorized) return false;
    if (menuItem.hiddenFor && location && menuItem.hiddenFor.includes(location)) return false;
    return true;
  });

  return filteredMenu.map((menuItem) => {
    let newItem = { ...menuItem };
    if (newItem.label === 'menu-media') {
      const existingSubMenu = newItem.subMenu ?? [];
      newItem.subMenu = [
        ...(hasNews
          ? [
              {
                id: 999,
                path: '/news',
                label: 'menu-media-news',
              },
            ]
          : []),
        ...existingSubMenu.filter((subItem) => subItem.path !== '/news'),
      ];
    }
    if (newItem.subMenu && Array.isArray(newItem.subMenu)) {
      newItem.subMenu = transformMenu(newItem.subMenu, options);
    }

    return newItem;
  });
}